import { Component, OnInit, Input } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { MainContainerService } from 'src/app/service/main-container.service';
import { ToastService } from 'src/app/service/toast.service';
import { GatePass } from 'src/app/model/Security/GatePass';
import { MaxGatePassNo, Company, Employee, Department } from 'src/app/model/Security/common';
import { Appointment } from 'src/app/model/Security/Appointment';
import { GatePassList } from 'src/app/model/Security/GatePassList';
import { GatePassService } from 'src/app/service/Security/gate-pass.service';
import { CommonService } from 'src/app/service/Security/common.service';
import { Constant } from 'src/app/common/constant';
import { LocalStorageService } from 'src/app/common/LocalStorageService';


@Component({
  selector: 'app-gate-pass',
  templateUrl: './gate-pass.component.html',
  styleUrls: ['./gate-pass.component.css']
})
export class GatePassComponent implements OnInit {

 
  @Input() notifyItemProcessed: () => void;

  newForm: UntypedFormGroup;
  editForm: UntypedFormGroup;
  tabGroup: { selectedIndex: any; };

  gatePass: GatePass = new GatePass();
  editGatePass: GatePass=new GatePass();

  maxgatepasses: Observable<MaxGatePassNo[]>;
  companies: Observable<Company[]>;

  employees: Observable<Employee[]>;
  departments: Observable<Department[]>;


  public GatePassTypes:string[];
  public GatePassfixedbyes:string[];
  date: Date;
  data = "";
  defaultCompany = "";
  http: any;
  private editmode: boolean = false
  apiFactory: any;
  yesNoList: string[];
  testId: Number;
  result: string;
  entryVeh="";
  entryPac="";
  entryRem="";

  disableOTPButton:boolean=true;
  disablePassEmpButton:boolean=true;

  viewAppointment=new Appointment();

  GatePassAppointmentList: GatePassList[];

  editing: boolean = false;
  GatePassSubcription: Subscription;
  GatePassList: GatePass[];
  
  defviewAppointmentNo:string;
 
   viewtableColumns: string[] = ['ref_no','gatepass_date','gatepass_time','visitor_name','visitor_company','address','purpose','vehicle_no','no_of_packets_if_any','employee_permitted','employee_message'];
  deletetableColumns: string[] = ['ref_no','gatepass_date','gatepass_time','visitor_name','visitor_company','address','purpose','vehicle_no','no_of_packets_if_any','employee_permitted','employee_message', 'cancel'];
 
  viewDataAvail: boolean;
  editDataAvail: boolean=false;
  appointmentSubcription: Subscription;
  appointmentList: Appointment[];

  modeOfPermission: string[];
  viewDataEntryAvail:boolean=false;
  defaultVisitorRefNo:String;

  noOfDaysAllowed: any;
  ActiveTab: number;
  maxAllowDate: Date = new Date();
  constructor(
    public persistenceService: LocalStorageService,
    
    private toastService: ToastService,private mainContainerService: MainContainerService, private fb: UntypedFormBuilder, private gatePassService: GatePassService, private commonService: CommonService, private constant: Constant) {
    this.newForm = this.fb.group({
      ref_no: ['', Validators.required],
      company_id: ['', Validators.required],
      gatepass_date: ['', Validators.required],
      gatepass_time: ['', Validators.required],
      visitor_ref_no: ['', Validators.required],
      
      vehicle_no: ['', Validators.required],
      no_of_packets_if_any: ['', Validators.required],
      remarks_if_any: ['', Validators.required],
      otp_generated: ['', Validators.required],
      otp_received: ['', Validators.required],
     
      employee_permitted: ['', Validators.required],
      employee_permitted_through: ['', Validators.required],
      employee_message: ['', Validators.required]
    });
    this.editForm = this.fb.group({
      ref_no: ['', Validators.required],
      company_id: ['', Validators.required],
      gatepass_date: ['', Validators.required],
      gatepass_time: ['', Validators.required],
      visitor_ref_no: ['', Validators.required],
      
      vehicle_no: ['', Validators.required],
      no_of_packets_if_any: ['', Validators.required],
      remarks_if_any: ['', Validators.required],
      otp_generated: ['', Validators.required],
      otp_received: ['', Validators.required],
     
      employee_permitted: ['', Validators.required],
      employee_permitted_through: ['', Validators.required],
      employee_message: ['', Validators.required]
      

    });
  }
  
  ngOnInit() {
    this.defaultCompany = this.constant.defaultCompanyName;
    this.yesNoList=this.constant.yesNoList;
    this.companies = this.commonService.getCompanyList();
    this.maxgatepasses = this.commonService.getMaxGatePassNo();
    this.gatePass.gatepass_date = this.commonService.getCurrentDate();
    this.modeOfPermission=this.constant.modeOfPermission;
    this.gatePass.gatepass_time = this.commonService.getCurrentTime();
    this.modeOfPermission=this.constant.modeOfPermission;
    this.modeOfPermission=this.constant.modeOfPermission;
    this.gatePass.company_id=this.constant.defaultCompany;
    this.getGatePassList();
    this.getAppointmentList();
  }
  getAppointmentList() {
    this.appointmentSubcription = this.commonService.getAppointmentList().subscribe((data) => {
      let result: Appointment[] = data;
      this.appointmentList = result;
      if (this.appointmentList.length === 0) {
        this.viewDataAvail = false;
      }
      else
        this.viewDataAvail = true;
    });
  }

  getGatePassList() {
    this.GatePassSubcription = this.commonService.getGatePassList().subscribe((data) => {
      let result: GatePass[] = data;
      this.GatePassList = result;
      if (this.GatePassList.length === 0) {
        this.viewDataAvail = false;
      }
      else
        this.viewDataAvail = true;
    });
  }

  getGatePassVSAppointmentList() {
    this.GatePassSubcription = this.commonService.getGatePassVSAppointmentList().subscribe((data) => {
      let result: GatePassList[] = data;
      this.GatePassAppointmentList = result;
      if (this.GatePassList.length === 0) {
        this.viewDataAvail = false;
      }
      else
        this.viewDataAvail = true;
    });
    
  }
  onEditGatePassSelect(id:any)
  {
    this.commonService.getGatePassById(id)
      .subscribe(data => {
        console.log(data);
        this.editGatePass = data;
        //this.onEditGatePassAppointmentSelect(this.editGatePass.visitor_ref_no);
        this.defaultVisitorRefNo=this.editGatePass.visitor_ref_no.toString();
        this.editmode = true;
        this.editDataAvail = true;
        alert(this.editGatePass.visitor_ref_no);
      }, error => console.log(error));
      this.defviewAppointmentNo=this.editGatePass.visitor_ref_no.toString();
  }
  saveEditGatePass(event: any) {
    this.gatePass.ref_no = event.target.ref_no.value;
    this.gatePassService.createGatePass(this.editGatePass)
      .subscribe(data => console.log(data), error => console.log(error));
    this.toastService.showSuccessToast("GatePass " + this.constant.savedSuccessfullyWithModuleToast);
    this.getGatePassList();
    this.getAppointmentList();
  }
  onEditGatePassAppointmentSelect(id: any)
  {
    this.commonService.getAppointmentListById(id)
    .subscribe(data => {
      console.log(data);
      this.viewAppointment = data;
      this.viewDataEntryAvail=true
      this.editGatePass.visitor_ref_no=id;
    }, error => console.log(error));
  }
  onCancelGatePassAppointmentClick(id: any) {
    this.GatePassSubcription = this.commonService.deleteGatePassAppointment(id).subscribe((data) => {
    });
    this.getGatePassVSAppointmentList();
    this.ngOnInit();
    this.getAppointmentList();
    this.toastService.showSuccessToast(this.constant.cancelSuccessfullyToast);
  }
  onCreateGatePassSelect(id : any)
  {
    this.commonService.getAppointmentListById(id)
      .subscribe(data => {
        console.log(data);
        this.editmode = true;
        this.viewDataEntryAvail = true;
        let result: Appointment = data;
        this.viewAppointment = result;
        this.disablePassEmpButton=true;
        this.disableOTPButton=true;
        this.gatePass.visitor_ref_no=id;
      }, error => console.log(error));
  }



  saveGatePass(event: any) {
    this.gatePass.ref_no = event.target.ref_no.value;
    
    this.gatePassService.createGatePass(this.gatePass)
      .subscribe(data => console.log(data), error => console.log(error));
    this.toastService.showSuccessToast("GatePass " + this.constant.savedSuccessfullyWithModuleToast);
    //this.gatePass = new GatePass();
    this.ngOnInit();   
  }
 
  tabClicked(event: any) {
    if (event.index == 1 || event.index == 2 || event.index == 3) {
      this.getGatePassVSAppointmentList();
      this.getAppointmentList();
      this.getGatePassList();
    }
    else
    {
      this.ngOnInit();
      this.editmode = false;
    }
  }
  generateOTP()
  {
    this.gatePass.otp_generated="myotp";
    this.toastService.showSuccessToast(this.constant.OTPToast);
    
  }
  checkOTPReceive(id:any)
  {
    if(id=="myotp")
    {
      this.toastService.showSuccessToast(this.constant.OTPverfiedToast);
      this.disablePassEmpButton=false;
      this.disableOTPButton=true;
    }
    else
    {
      this.disablePassEmpButton=true;
      this.disableOTPButton=false;
    }
  }
  generatePass()
  {
    alert("Pass Generated");
  }
  askedToEmployee()
  {
    alert("Asked");
  }
  checkDataVeh(id: any)
  {
    if(id.length==0)
      this.entryVeh="";
    else
      this.entryVeh=id;
    if(this.entryVeh.length>0 && this.entryPac.length>0 && this.entryRem.length>0)
      this.disableOTPButton=false;
    else
      this.disableOTPButton=true;
  }

  checkDataRem(id: any)
  {
    if(id.length==0)
      this.entryRem="";
    else
      this.entryRem=id;
    if(this.entryVeh.length>0 && this.entryPac.length>0 && this.entryRem.length>0)
      this.disableOTPButton=false;
    else
      this.disableOTPButton=true;
  }
  checkDataPac(id: any)
  {
    if(id.length==0)
      this.entryPac="";
    else
      this.entryPac=id;
    if(this.entryVeh.length>0 && this.entryPac.length>0 && this.entryRem.length>0)
      this.disableOTPButton=false;
    else
      this.disableOTPButton=true;
  }
  
}
